import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SourceSystemFactory } from "../classes/SourceSystem";
import { getAppraisalData } from "../store/selectors";

export const useSourceSystem = () => {
  const { sourceSystem: sourceSystemName, redirectURI, exitUri } = useSelector(
    getAppraisalData
  );
  
  const navigate = useNavigate();

  const sourceSystem = new SourceSystemFactory().getSourceSystem(
    sourceSystemName,
    redirectURI,
    navigate,
    exitUri
  );

  return { sourceSystem };
};
